// extracted by mini-css-extract-plugin
export var brand = "_2q-9";
export var compact = "_2q-6";
export var extraSmall = "_2q-7";
export var icon = "_2q-0";
export var large = "_2q-4";
export var light = "_2q-1";
export var medium = "_2q-5";
export var outline = "_2q-b";
export var primaryDark = "_2q-a";
export var primaryLight = "_2q-8";
export var primaryModern = "_2q-c";
export var success = "_2q-2";
export var successSolid = "_2q-3";